import { TABLE_HEADERS } from "consts";

export const DOCUMENTS_ROUTER = {
  TITLE: "Documents",
  PATH: "/documents/*",
};

export const COLLECTOR_LABEL = `Utility type / ${TABLE_HEADERS.accountNumber} / ${TABLE_HEADERS.meterNumber}`;